"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const ArrowLeft = ({ size = 16, fill = "#fff", name = "Arrow left", ...rest }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: `0 0 16 16`, fill: fill, ...rest },
        react_1.default.createElement("title", null, name),
        react_1.default.createElement("path", { d: "M8,4v3h6v2H8v3L2,8L8,4z" })));
};
exports.default = ArrowLeft;
//# sourceMappingURL=index.js.map